import styled from 'styled-components';

export const ContainerModal = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9000;
`;

export const Container = styled.div`
  width: 100%;
  max-width: 530px;
  background: #fff;
  border-radius: 16px;
  border: 1px solid #dedede;
`;

export const Header = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px 24px 0 24px;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  border-radius: 100%;
  width: 40px;
  height: 40px;
  background-color: #ffefea;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 24px 24px 24px;
  border-bottom: 1px solid #dedede;
`;

export const EmailSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 24px;
  border-bottom: 1px solid #dedede;
`;

export const EmailField = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 14px;
  border: 1px solid #dedede;
  border-radius: 8px;
  background-color: #f4f4f4;
  color: #656a6e;
  font-size: 14px;
  line-height: 20px;
  min-height: 40px;
`;

export const Footer = styled.footer`
  padding: 16px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`;
